import { css } from "@emotion/react";

import theme from "../../styles/theme";
import { grey, greySecondary, red, white } from "../../styles/variables";

const { spacing } = theme;

export const dialog = css`
  .MuiDialog-paper {
    background-color: transparent;
    box-shadow: none;
  }
`;

export const cardHeader = css`
  padding: ${spacing(2.5, 2.5, 0)};

  .MuiTypography-root {
    font-size: 18px;
    font-weight: bold;
  }
`;

export const cardContent = css`
  padding: ${spacing(2, 2.5)};
`;

export const section = css`
  display: flex;
  align-items: center;
`;

export const inputLabel = css`
  font-size: 12px;
  margin-bottom: ${spacing(2)}px;
`;

export const domainInput = css`
  input::placeholder {
    font-size: 14px;
    color: ${grey};
    opacity: 1;
  }
`;

export const disabled = css`
  .MuiInput-underline {
    &::before,
    &:hover:not(.Mui-disabled)::before,
    &::after,
    &.Mui-focused::after {
      border-color: ${greySecondary};
    }
  }
`;

export const exclamationIcon = css`
  width: 16px;
  height: 16px;
  border-radius: 4px;
  background-color: ${red};
  color: ${white};
  vertical-align: middle;
`;

export const sectionTitle = css`
  font-weight: bold;
  margin: ${spacing(2.5, 0, 1.5)};
`;

export const list = css`
  height: 127px;
  overflow-y: auto;
`;

export const listItem = css`
  & .MuiInputBase-input {
    padding: 10px 0 10px ${spacing(2)}px;
    font-size: 14px;
  }
`;

export const deleteIcon = css`
  cursor: pointer;
  margin-right: ${spacing(1.5)}px;
  color: ${red};
`;

export const actions = css`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${spacing(1.5)}px;
`;

export const actionsBorderSection = css`
  border-top: 2px solid ${greySecondary};
`;

export const button = css`
  width: 170px;
  height: 40px;
  margin-right: ${spacing(1)}px;

  &:last-of-type {
    margin-right: 0;
  }
`;
